import { Outlet } from 'react-router-dom'
import { useState } from 'react'
import Sidebar from './Sidebar'
import TopBar from './TopBar'
import Footer from './Footer'

const Layout = ({ children, pageTitle }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-950 via-slate-950 to-pink-900 flex flex-col relative overflow-hidden">
      {/* Soft glow background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -left-24 w-72 h-72 bg-purple-500/35 blur-3xl rounded-full" />
        <div className="absolute top-32 -right-32 w-80 h-80 bg-pink-500/35 blur-3xl rounded-full" />
        <div className="absolute -bottom-40 left-10 w-64 h-64 bg-slate-800/60 blur-3xl rounded-full" />
      </div>
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black bg-opacity-50"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      {/* Main content */}
      <div className="main-content flex flex-col flex-1 relative z-10 w-full">
        <TopBar onMenuClick={() => setSidebarOpen(true)} title={pageTitle || 'Dashboard'} />
        <main className="flex-1 bg-black/20 backdrop-blur-md w-full p-4 lg:p-8" style={{ paddingTop: '5.5rem' }}>
          {children}
        </main>
        <div className="w-full">
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default Layout
